
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/sources/google-pubsub",
      function () {
        return require("private-next-pages/events/sources/google-pubsub.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/sources/google-pubsub"])
      });
    }
  